import './app.scss'
import {
  Topbar,
  Menu,
  Inicio,
  Servicios,
  Nosotros,
  Instrumental,
  Contacto,
  Footer
} from './components';
import { useState } from 'react';


function App() {
  
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="app">
      <Topbar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Inicio/>
      <Servicios/>
      <Nosotros/>
      <Instrumental/>
      <Contacto/>
      <Footer/>
    </div>
  );
}

export default App;